import styled from "styled-components";

import { Frame, TExtra } from "./styled-templates";

import theme from "constants/theme-constants";

import { convertHex } from "services/colors-service";

import { ERequestStatus } from "types/enums";

export enum ELabelStatuses {
    Success = `success`,
    Error = `error`,
    Warning = `warning`,
}

const StatusLabelColors = {
    [ERequestStatus.New]: theme.blue,
    [ERequestStatus.Approved]: theme.green,
    [ERequestStatus.DoneVisited]: theme.nice_green,
    [ERequestStatus.DoneNotVisited]: theme.nice_green,
    [ERequestStatus.Rejected]: theme.red,
    [ERequestStatus.Review]: theme.yellow,
    [ERequestStatus.Canceled]: theme.red,
};

const StatusLabel = styled(Frame)<{ status: ELabelStatuses; extra?: TExtra }>`
    padding: 6.5px 18px;
    border-radius: 9999px;
    box-sizing: border-box;
    background: ${({ status, theme }) => convertHex(StatusLabelColors[status] ?? theme.grey, 0.3)};
    width: max-content;

    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    color: ${({ status, theme }) => StatusLabelColors[status] ?? theme.grey};
`;

export const BookingStatuses = {
    [ERequestStatus.New]: `Новая`,
    [ERequestStatus.Approved]: `Одобрено`,
    [ERequestStatus.Rejected]: `Отклонено`,
    [ERequestStatus.Review]: `На рассмотрении`,
    [ERequestStatus.Canceled]: `Отменено`,
    [ERequestStatus.DoneVisited]: `Исполнено:Приехал`,
    [ERequestStatus.DoneNotVisited]: `Исполнено:Не приехал`,
};

export default StatusLabel;
